import { computed } from '@angular/core';
import { signalStoreFeature, type, withComputed } from '@ngrx/signals';
import { HelpState } from './help.state';
import { StateFilter } from '../crud.state';
import { Help } from '../../models/help';

const filterItems = (items: Help[], filter: StateFilter, products = false) => {
  return items.filter(item => {
    const titleMatch = item.title
      .toLowerCase()
      .includes(filter.query.toLowerCase());

    const idMatch =
      !filter.ids ||
      filter.ids.length === 0 ||
      filter.ids.includes(item._id) ||
      filter.ids.includes(item._id);

    return titleMatch && idMatch;
  });
};

export function withHelpSelectors() {
  return signalStoreFeature(
    {
      state: type<HelpState>(),
    },
    withComputed(({ items, filter, selectedId }) => ({
      count: computed(() => Object.keys(items()).length),
      asArray: computed(() => {
        return Object.values(items()).sort((a, b) =>
          a.title < b.title ? -1 : 1
        );
      }),
      allKeys: computed((): string[] => {
        return Object.values(items()).map(item => item.key);
      }),
      filteredSortedByName: computed(() => {
        let filtered = Object.values(items());
        if (filter()) {
          filtered = filterItems(filtered, filter());
        }
        return filtered.sort((a, b) => (a.title < b.title ? -1 : 1));
      }),
      activeHelpItem: computed((): Help | undefined => {
        const key = selectedId();
        if (!key) return undefined;
        const all = items();
        for (const id in all) {
          const item = all[id];
          if (item && item.key === key) return item;
        }
        return undefined;
      }),
    }))
  );
}
